import { Stack, Typography, type StackProps, type TypographyProps } from '@mui/material';
import { isNotNullOrUndefined } from '@vy/utils';

type LivePreviewContainerHeaderLabelProps =
  | {
      title: string;
      value: string;
      render?: never;
      containerProps?: StackProps;
    }
  | {
      title: string;
      value?: never;
      render: (props: Partial<TypographyProps>) => React.ReactNode;
      containerProps?: StackProps;
    };

export const LivePreviewContainerHeaderLabel: React.FC<LivePreviewContainerHeaderLabelProps> = ({
  title,
  value,
  render,
  containerProps,
}) => {
  const typographyProps: Partial<TypographyProps> = {
    sx: {
      fontWeight: 300,
      fontSize: '12px',
      lineHeight: '16px',
    },
  };

  return (
    <Stack
      direction="row"
      {...containerProps}
      sx={[{
        gap: "4px"
      }, ...(Array.isArray(containerProps?.sx) ? containerProps.sx : [containerProps?.sx])]}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "12px",
          lineHeight: "16px"
        }}>
        {title}
      </Typography>
      {isNotNullOrUndefined(render) ? (
        <>{render(typographyProps)}</>
      ) : (
        <Typography {...typographyProps}>{value}</Typography>
      )}
    </Stack>
  );
};
